import store from '@/store'
import { computed } from '@vue/composition-api'
import { postData } from '@core/utils/http/general'

export default () => {
  const currentRol = store.state.cuenta.rolSelected.id // * Rol de usuario actual

  // * Prioridades disponibles por rol de usuario
  const availablePriorities = computed(() => {
    const priorityByRol = {
      1: [{ color: 'warning', value: 'MEDIA' }],
      2: [{ color: 'success', value: 'BAJA' }, { color: 'warning', value: 'MEDIA' }, { color: 'danger', value: 'ALTA' }],
      3: [{ color: 'success', value: 'BAJA' }, { color: 'warning', value: 'MEDIA' }, { color: 'danger', value: 'ALTA' }],
    }

    return priorityByRol[currentRol] || ''
  })

  // * Tipos de link disponible por rol de usuario tipo: [0: liga interna - 1: liga externa]
  const availableUrlTypes = computed(() => {
    const urlTypeByRol = {
      2: [{ tipo: 1, label: 'Liga externa', icon: 'ExternalLinkIcon' }],
      3: [{ tipo: 0, label: 'Liga interna', icon: 'CheckSquareIcon' }, { tipo: 1, label: 'Liga externa', icon: 'ExternalLinkIcon' }],
    }

    return urlTypeByRol[currentRol] || ''
  })

  // * Lista de a quien puede envíar notificación disponibles por rol de usuario
  const availableTo = computed(() => {
    const toByRol = {
      2: ['ALUMNO', 'USUARIO', 'PLAN', 'PERIODO', 'CURSO'],
      3: ['ALUMNO', 'USUARIO', 'PLAN', 'PERIODO', 'CURSO', 'GRUPO', 'TODOS'],
    }

    return toByRol[currentRol] || ''
  })

  // * Dynamic component by rol [active-notification-switch]
  const availableComponentActiveSwitch = computed(() => {
    const availableByRol = {
      2: 'active-notification-switch',
      3: 'active-notification-switch',
    }

    return availableByRol[currentRol] || ''
  })

  // * Dynamic component by rol [url-notification-input]
  const availableComponentUrlInput = computed(() => {
    const availableByRol = {
      2: 'url-notification-input',
      3: 'url-notification-input',
    }

    return availableByRol[currentRol] || ''
  })

  // * Dynamic component by rol [url-notification-input]
  const availableComponentExpireInput = computed(() => {
    const availableByRol = {
      2: 'expire-notification-input',
      3: 'expire-notification-input',
    }

    return availableByRol[currentRol] || ''
  })

  // * Dynamic component by rol [url-notification-type-dropdown]
  const availableComponentUrlTypeDropdown = computed(() => {
    const availableByRol = {
      2: 'url-notification-type-dropdown',
      3: 'url-notification-type-dropdown',
    }

    return availableByRol[currentRol] || ''
  })

  // * Dynamic component by rol [priority-notification-dropdown]
  const availableComponentPriorityDropdown = computed(() => {
    const availableByRol = {
      2: 'priority-notification-dropdown',
      3: 'priority-notification-dropdown',
    }

    return availableByRol[currentRol] || ''
  })

  // * Dynamic component by rol [to-notification-field]
  const availableComponentToField = computed(() => {
    const availableByRol = {
      2: 'to-notification-field',
      3: 'to-notification-field',
    }

    return availableByRol[currentRol] || ''
  })

  // * Save notification
  const saveData = dataParam => new Promise((resolve, reject) => {
    const data = new FormData()
    data.append('task', 'wsnotificacion')
    data.append('origin', process.env.VUE_APP_ORIGIN_API)
    data.append('token', store.state.cuenta.session.token)
    data.append('x', currentRol)
    Object.entries(dataParam).forEach(element => { data.append(element[0], element[1]) })

    postData(data)
      .then(response => {
        if (response.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  return {
    // Methods
    saveData,

    // Data
    availablePriorities,
    availableUrlTypes,
    availableTo,

    // Dynamic Components
    availableComponentActiveSwitch,
    availableComponentUrlInput,
    availableComponentExpireInput,
    availableComponentUrlTypeDropdown,
    availableComponentPriorityDropdown,
    availableComponentToField,
  }
}
